import "mdn-polyfills/Element.prototype.closest"; // IE11
import "mdn-polyfills/Array.from"; // IE11
import extend from "../../utils/extend";

// reportValidity() polyfill for IE11, see : https://gist.github.com/nuxodin/73a2c2423cbbf6818c28ad803985d5c7
if (!HTMLFormElement.prototype.reportValidity) {
  HTMLFormElement.prototype.reportValidity = function () {
    if (this.checkValidity()) return true;
    const btn = document.createElement("button");
    this.appendChild(btn);
    btn.click();
    this.removeChild(btn);
    return false;
  };
}

export default class StepForm {
  constructor($form, settings) {
    const _ = this;

    _.$form = $form;

    _.settings = extend(
      true,
      {
        stepsSectionSelector: ".stepform-section",
        navNextSelector: ".stepform-next",
        startIndex: 0,
        callbacks: {
          onSectionDisplay: () => {},
          onSectionHide: () => {},
        },
      },
      settings || {}
    );

    _.$sections = _.$form.querySelectorAll(_.settings.stepsSectionSelector);
    _.$nexts = _.$form.querySelectorAll(_.settings.navNextSelector);
    _.$submits = _.$form.querySelectorAll('[type="submit"]');

    _.currentSectionIndex = null;

    _.handleNextClick = _.handleNextClick.bind(_);
    _.handleSubmitClick = _.handleSubmitClick.bind(_);

    if (
      _.settings.startIndex !== 0 &&
      _.settings.startIndex > _.$sections.length + 1
    ) {
      _.settings.startIndex = 0;
    }
  }

  mount() {
    const _ = this;

    for (let i = 0; i < _.$sections.length; i++) {
      _.$sections[i].style.display = "none";
    }

    for (let i = 0; i < _.$nexts.length; i++) {
      _.$nexts[i].addEventListener("click", _.handleNextClick);
    }
    for (let i = 0; i < _.$submits.length; i++) {
      _.$submits[i].addEventListener("click", _.handleSubmitClick);
    }

    _.displaySection(_.currentSectionIndex || _.settings.startIndex);
  }

  dismount() {
    const _ = this;

    for (let i = 0; i < _.$sections.length; i++) {
      _.$sections[i].style.display = "";
    }

    for (let i = 0; i < _.$nexts.length; i++) {
      _.$nexts[i].removeEventListener("click", _.handleNextClick);
    }
    for (let i = 0; i < _.$submits.length; i++) {
      _.$submits[i].removeEventListener("click", _.handleSubmitClick);
    }
  }

  displaySection(index, withScroll = false) {
    const _ = this;

    if (_.currentSectionIndex !== null) {
      _.hideSection(_.currentSectionIndex);
    }

    _.currentSectionIndex = index;
    _.$sections[_.currentSectionIndex].style.display = "";

    _.settings.callbacks.onSectionDisplay(_, index);

    if (withScroll) {
      _.$sections[_.currentSectionIndex].scrollIntoView();
    }
  }

  hideSection(index) {
    const _ = this;

    _.$sections[index].style.display = "none";
    _.currentSectionIndex = null;

    _.settings.callbacks.onSectionHide(_, index);
  }

  handleNextClick(e) {
    const _ = this;

    e.preventDefault();

    if (_.checkSectionValidity(_.currentSectionIndex)) {
      _.displaySection(_.currentSectionIndex + 1, true);
    } else {
      _.$form.reportValidity();
    }
  }

  handleSubmitClick(e) {
    /* global grecaptcha */
    const _ = this;
    const useRecaptcha =
      e.currentTarget.getAttribute("data-recaptcha") !== null;

    e.preventDefault();

    if (_.checkSectionValidity(_.currentSectionIndex)) {
      if (useRecaptcha) {
        grecaptcha.execute();
      } else {
        _.$form.submit();
      }
    } else {
      _.$form.reportValidity();
    }
  }

  checkSectionValidity(index) {
    const _ = this;

    const $inputs = _.$sections[index].querySelectorAll(
      "input, textarea, select"
    );
    for (let i = 0; i < $inputs.length; i++) {
      if (!$inputs[i].checkValidity()) {
        return false;
      }
    }

    return true;
  }
}
